const { getElement } = window.BAO.Utils

class MahinaNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.sections = this.els.link.elements
      .map((linkEl) => getElement(linkEl.getAttribute('href')))
      .filter((sec) => sec)

    this.observeItems()
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach((linkEl) => {
      this.listeners.add(linkEl, 'click', this.goToSection)
    })
  }

  observeItems () {
    const links = this.els.link.elements

    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    }

    function observerCallback (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          links.forEach((linkEl) => {
            const isActive =
              linkEl.getAttribute('href').replace('#', '') === entry.target.id
            linkEl.setAttribute('aria-active', isActive)
          })
        }
      })
    }

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions,
    )

    this.externalEls.section.elements.forEach((sec) => observer.observe(sec))
  }

  goToSection (e) {
    e.preventDefault()

    const targetId = e.target.getAttribute('href')
    const target = getElement(targetId)

    const header = getElement('.hd-Banner')

    const headerHeight = header.offsetHeight + 30

    window.scrollTo({
      top: target.offsetTop - headerHeight,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('mahina-navigation')) {
  customElements.define('mahina-navigation', MahinaNavigation)
}
